export function hasBtn(btnName)
{
    let btn = JSON.parse(sessionStorage.getItem('btnList'))||[];
    if (btn.length==0){
        return null
    }else {
        var link=[];
        btn.forEach(function(e,i) {
            link[i]=e.link;
        });
        return link.indexOf(btnName) > -1;
    }
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function router_url(url,query) {
    var date = new Date().getTime();
    var query_obj={
        t:date
    };
    if (query) {
        query['t']=date;
    }else{
        query=query_obj
    }
    this.$router.push({
        path: url,
        query:query
    });
}
export function getTime(/** timestamp=0 **/) {  
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    // t = getDate(parseInt(ts*1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='yyyy'){
        return y
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}

// 是否是手机
export function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
    var mobile_flag = false;
    //根据userAgent判断是否是手机
    for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
      }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;   
    //根据屏幕分辨率判断是否是手机
    if(screen_width < 500 && screen_height < 800){
       mobile_flag = true;
    }
    return mobile_flag;
}


/**
 * 获取屏幕高度
 * @param {number} height 要减去的高度
 * @return {number}
 */
export function screenHeight(height = 0) {
    var deduct=230 - 50;
    var defaultHeight = 880
    var winHeight;
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
    }
    if (winHeight) {
        return winHeight - height - deduct
    } else {
        return defaultHeight - height - deduct
    }
}
const aRouter = []
export const formatRoutes = (aMenu) => {
    aMenu.forEach(oMenu => {
        const {link, name, icon_url, Menu,menu_type } = oMenu
        if(Menu&&Menu.length>0){
            formatRoutes(Menu);
        }
        if(link&&menu_type==2){
            const oRouter = {
                path:link,
                name:name,
                icon: icon_url,
                component:loadView(link.replace('_','/')),
            }
            aRouter.push(oRouter)
        }
    })
    return aRouter
}
export const loadView = (view) => {
  return resolve => require([`@/views/${view}`], resolve).catch(err => {
  })
}


// WEBPACK FOOTER //
// ./src/utils/index.js